"use client";

import { ChevronDown } from "lucide-react";
import { useId, useState, type ReactNode } from "react";

type CcServicesAllToggleProps = {
  open: string;
  close: string;
  children: ReactNode;
};

/**
 * A small "see all services" button that folds the full sub-page list out
 * under the main service cards. The links stay in the HTML while folded
 * (inert, so they are skipped by keyboard and screen readers until opened).
 */
export function CcServicesAllToggle({
  open,
  close,
  children,
}: CcServicesAllToggleProps) {
  const [expanded, setExpanded] = useState(false);
  const id = useId();

  return (
    <div className="cc-hsf-more" data-open={expanded}>
      <button
        type="button"
        className="cc-hsf-more__button"
        aria-expanded={expanded}
        aria-controls={id}
        onClick={() => setExpanded((value) => !value)}
      >
        {expanded ? close : open}
        <ChevronDown size={14} strokeWidth={1.8} aria-hidden="true" />
      </button>
      <div id={id} className="cc-hsf-more__panel" inert={!expanded}>
        <div className="cc-hsf-more__inner">{children}</div>
      </div>
    </div>
  );
}
